







































































































































































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import VueSlider from 'vue-slider-component'
import FilterInfo from './atoms/FilterInfo.vue'

@Component({
  components: {
    VueSlider,
    FilterInfo
  }
})

export default class ProductFilters extends Vue {
  @Prop({ type: Array })
  filters!: Array<Filter>

  @Prop({ type: Boolean })
  showSearchBox!: boolean

  @Prop({ type: Boolean })
  showClearAll!: boolean

  @Prop({ type: Boolean })
  showCounts!: boolean

  @Prop({ type: Boolean })
  showItemsWithNoResults!: boolean

  @Prop({ type: Boolean })
  isLoading!: boolean

  @Prop({ type: String })
  id!: string

  @Prop({ type: Boolean })
  useInfoPopOver!: boolean

  @Prop({ type: Number })
  maxOptions!: number

  timeoutSearchQuery = ''

  private searchTimeout = 0

  private toggleFilterActive (filter: FilterOption, filterGroup: Filter) {
    const active = filter.Active
    if (filterGroup.Type === 'radio') {
      // radiobox
      this.clearFilterGroup(filterGroup)
      filter.Active = !active
    } else {
      // checkbox
      Vue.set(filter, 'Active', !filter.Active)
    }

    this.$emit('filter')
  }

  private toggleOptionsVisible (filterGroup: Filter) {
    filterGroup.AllOptionsVisible = !filterGroup.AllOptionsVisible
  }

  private toggleRangeChanged () {
    this.$emit('filter')
  }

  private calcMinValue (filter: FilterOption) {
    return filter.RangeValue[0] > filter.Range[0] ? filter.Range[0] : filter.RangeValue[0]
  }

  private calcMaxValue (filter: FilterOption) {
    return filter.RangeValue[1] < filter.Range[1] ? filter.Range[1] : filter.RangeValue[1]
  }

  private setSearchTimeout () {
    window.clearTimeout(this.searchTimeout)
    this.searchTimeout = window.setTimeout(() => {
      this.$emit('search', this.timeoutSearchQuery)
    }, 400)
  }

  private clearFilterGroup (filterGroup: Filter) {
    filterGroup.Options.forEach(filter => {
      filter.Active = false
    })
  }

  public setSearchQuery (searchQuery: string) {
    this.timeoutSearchQuery = searchQuery
  }

  public emitClearAll (event: { preventDefault: () => void }) {
    event.preventDefault()
    this.$emit('clearAll')
  }
}
